/**
 * @typedef {object} SearchDataOfProduct Tracked info about a search related to a product
 * @property {Number} count search count
 * @property {String} match search match
 * @property {String} query search query
 */

module.exports = {};
